// extracted by mini-css-extract-plugin
export default {"badge":"TicketDeletedVoucherGroup_badge__qA4Bv","animate":"TicketDeletedVoucherGroup_animate__ZHfuc"};